import React, { useState, useEffect, useRef } from "react";
import { useMediaPlayer } from "@vidstack/react";
import { FaVolumeUp, FaChevronDown } from "react-icons/fa";

const AudioTrackSelector = () => {
  const player = useMediaPlayer();
  const [audioTracks, setAudioTracks] = useState([]);
  const [currentTrack, setCurrentTrack] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    if (!player) return;

    const updateTracks = () => {
      const tracks = player.audioTracks;
      if (tracks && tracks.length > 0) {
        setAudioTracks(Array.from(tracks));
        const selected = tracks.selectedTrack;
        setCurrentTrack(selected || tracks[0] || null);
      } else {
        setAudioTracks([]);
        setCurrentTrack(null);
      }
    };

    updateTracks();

    const handleTracksChange = () => {
      updateTracks();
    };

    player.addEventListener("audio-tracks-change", handleTracksChange);
    player.addEventListener("loaded-metadata", updateTracks);

    return () => {
      player.removeEventListener("audio-tracks-change", handleTracksChange);
      player.removeEventListener("loaded-metadata", updateTracks);
    };
  }, [player]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  const selectTrack = (track) => {
    if (player && track) {
      player.audioTracks.selectedTrack = track;
      setCurrentTrack(track);
      setIsOpen(false);
    }
  };

  if (!audioTracks || audioTracks.length <= 1) {
    return null;
  }

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 px-3 py-2 bg-gray-800 hover:bg-gray-700 text-white rounded-lg transition-all duration-300 text-sm"
        title="انتخاب ترک صوتی"
      >
        <FaVolumeUp className="text-base" />
        <span className="font-medium">
          {currentTrack?.label || currentTrack?.language || "صدا"}
        </span>
        <FaChevronDown
          className={`text-xs transition-transform duration-300 ${
            isOpen ? "rotate-180" : ""
          }`}
        />
      </button>

      {isOpen && (
        <div className="absolute bottom-full left-0 mb-2 w-48 bg-gray-800 rounded-lg shadow-xl border border-gray-700 overflow-hidden z-50">
          <div className="max-h-60 overflow-y-auto">
            {audioTracks.map((track, index) => (
              <button
                key={index}
                onClick={() => selectTrack(track)}
                className={`w-full text-right px-4 py-2 text-sm transition-colors duration-200 ${
                  currentTrack === track
                    ? "bg-yellow-700 text-white"
                    : "text-gray-300 hover:bg-gray-700 hover:text-white"
                }`}
              >
                <div className="flex items-center justify-between">
                  <span className="font-medium">
                    {track.label || track.language || `ترک ${index + 1}`}
                  </span>
                  {currentTrack === track && (
                    <span className="text-yellow-400">✓</span>
                  )}
                </div>
                {track.language && track.language !== track.label && (
                  <div className="text-xs text-gray-400 mt-1">{track.language}</div>
                )}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default AudioTrackSelector;

